module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("First published in Great Britain in 2020 by")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Pen & Sword Transport")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("An imprint of Pen & Sword Books Ltd")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Yorkshire - Philadelphia")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Copyright © David Maidment, 2020")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("ISBN 978 1 52675 205 5")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("ePUB ISBN 978 1 52675 206 2")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Mobi ISBN 978 1 52675 207 9")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("The right of David Maidment to be identified as the author of this work has been asserted by him in accordance with the Copyright, Designs and Patents Act 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("A CIP catalogue record for this book is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopy, recording or any information storage and retrieval system, without the prior written permission of the publisher, nor by way of trade or otherwise shall it be lent, re-sold, hired out or otherwise circulated without the publisher’s prior consent in any form of binding or cover other than that in which it is published and without a similar condition including this condition being imposed on the subsequent purchaser.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Pen & Sword Books Ltd incorporates the Imprints of Pen & Sword Books Archaeology, Atlas, Aviation, Battleground, Discovery, Family History, History, Maritime, Military, Naval, Politics, Railways, Select, Transport, True Crime, Fiction, Frontline Books, Leo Cooper, Praetorian Press, Seaforth Publishing, Wharncliffe and White Owl.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("For a complete list of Pen & Sword titles please contact")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("PEN & SWORD BOOKS LIMITED")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("47 Church Street, Barnsley, South Yorkshire, S70 2AS, England")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("E-mail: "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "mailto://enquiries@pen-and-sword.co.uk",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("enquiries@pen-and-sword.co.uk")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Website: "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.pen-and-sword.co.uk",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.pen-and-sword.co.uk")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Or")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("PEN AND SWORD BOOKS")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("1950 Lawrence Rd, Havertown, PA 19083, USA")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("E-mail: "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "mailto:Uspen-and-sword@casematepublishers.com"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Uspen-and-sword@casematepublishers.com")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Website: "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.penandswordbooks.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.penandswordbooks.com")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("All David Maidment’s royalties from this book will be donated to the Railway Children charity [reg. no. 1058991] ["), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.railwaychildren.org.uk",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.railwaychildren.org.uk")])])]), _vm._v("]")]), _vm._v(" "), _c('p', {
    staticClass: "copy3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Other books by David Maidment:")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Novels (Religious historical fiction)")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Child Madonna")]), _vm._v(", Melrose Books, 2009")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Missing Madonna")]), _vm._v(", PublishNation, 2012")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Madonna and her Sons")]), _vm._v(", PublishNation, 2015")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Novels (Railway fiction)")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Lives on the Line")]), _vm._v(", Max Books, 2013")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Non-fiction (Railways)")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Toss of a Coin")]), _vm._v(", PublishNation, 2014")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A Privileged Journey")]), _vm._v(", Pen & Sword, 2015")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("An Indian Summer of Steam")]), _vm._v(", Pen & Sword, 2015")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Great Western Eight-Coupled Heavy Freight Locomotives")]), _vm._v(", Pen & Sword, 2015")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Great Western Moguls and Prairies")]), _vm._v(", Pen & Sword, 2016")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Southern Urie and Maunsell 2-cylinder 4-6-0s,")]), _vm._v(" Pen & Sword, 2016")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Great Western Small-Wheeled Double-Framed 4-4-0s,")]), _vm._v(" Pen & Sword, 2017")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Development of the German Pacific Locomotive,")]), _vm._v(" Pen & Sword 2017")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Great Western Large-Wheeled Double-Framed 4-4-0s,")]), _vm._v(" Pen & Sword 2017")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Great Western Counties, 4-4-0s, 4-4-2Ts & 4-6-0s,")]), _vm._v(" Pen & Sword 2018")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Southern Maunsell Moguls and Tank Engines,")]), _vm._v(" Pen & Sword 2018")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Great Western Granges,")]), _vm._v(" Pen & Sword, 2019")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Cambrian Railways Gallery,")]), _vm._v(" Pen & Sword, 2019")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Southern Maunsell 4-4-0s,")]), _vm._v(" Pen & Sword, 2019")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Great Western Panniers,")]), _vm._v(" Pen & Sword, 2019")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Great Western Kings,")]), _vm._v(" Pen & Sword, 2020")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Non-fiction (Street Children)")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Other Railway Children")]), _vm._v(", PublishNation, 2012")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Nobody ever listened to me")]), _vm._v(", PublishNation, 2012")]), _vm._v(" "), _c('p', {
    staticClass: "copy3a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Front cover photo:")])]), _vm._v(" "), _c('p', {
    staticClass: "copyd"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Taff Vale")]), _vm._v(" class ‘A’ tank No.385 at Cathays, 1956. "), _c('span', {
    staticClass: "caps"
  }, [_vm._v("Colour Rail /J.Harrison")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6658 with")]), _vm._v(" a freight leaving Barry Docks, c1958. "), _c('span', {
    staticClass: "caps"
  }, [_vm._v("John Hodge")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e620bc9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Copyright.vue
// module id = 63
// module chunks = 0